import type { SaleMode, WeightEstimate, ServingEstimate, PortionSize } from '@paulownia/shared/types';
import { SaleModeFields } from '../SaleModeFields';
import { SALE_MODES } from '../sale-mode-config';

interface WizardStepPricingProps {
  saleMode: SaleMode;
  price?: number;
  weightEstimate?: WeightEstimate;
  servingEstimate?: ServingEstimate;
  portionSizes?: PortionSize[];
  disclaimer?: string;
  onPriceChange: (price: number | undefined) => void;
  onWeightEstimateChange: (estimate: WeightEstimate | undefined) => void;
  onServingEstimateChange: (estimate: ServingEstimate | undefined) => void;
  onPortionSizesChange: (sizes: PortionSize[]) => void;
  onDisclaimerChange: (disclaimer: string | undefined) => void;
}

export function WizardStepPricing({
  saleMode,
  price,
  weightEstimate,
  servingEstimate,
  portionSizes,
  disclaimer,
  onPriceChange,
  onWeightEstimateChange,
  onServingEstimateChange,
  onPortionSizesChange,
  onDisclaimerChange,
}: WizardStepPricingProps) {
  const selectedMode = SALE_MODES.find(m => m.mode === saleMode);

  return (
    <div className="space-y-4">
      <div className="text-center mb-6">
        <h2 className="text-lg font-semibold text-gray-900">Définissez le prix</h2>
        {selectedMode && (
          <p className="text-sm text-gray-500 mt-1">
            Mode : <span className="font-medium">{selectedMode.label}</span>
          </p>
        )}
      </div>

      <SaleModeFields
        saleMode={saleMode}
        price={price}
        weightEstimate={weightEstimate}
        servingEstimate={servingEstimate}
        portionSizes={portionSizes}
        disclaimer={disclaimer}
        onPriceChange={onPriceChange}
        onWeightEstimateChange={onWeightEstimateChange}
        onServingEstimateChange={onServingEstimateChange}
        onPortionSizesChange={onPortionSizesChange}
        onDisclaimerChange={onDisclaimerChange}
      />
    </div>
  );
}
